import { AddressPage } from 'src/pages/Address'
import { ConclusionPage } from 'src/pages/Conclusion'
import { ConfirmationPage } from 'src/pages/Confirmation'
import { DocumentsPage } from 'src/pages/Documents'
import { MaintenancePage } from 'src/pages/Maintenance'
import { PersonalDataPage } from 'src/pages/PersonalData'
import { ResponsiblePage } from 'src/pages/Responsible'
import { SearchPage } from 'src/pages/Search'
import { TermsPage } from 'src/pages/Terms'
import { InitialPage } from './pages/Initial'
import { InstructionsPage } from './pages/Instructions'

export interface IAppRoute {
  name: string
  title: string
  path: string
  componentByCourse: { business: any; tech: any; vet: any }
}

export const COURSES = { business: 'business', tech: 'tech', vet: 'vet' }

export const BASE_ROUTES = {
  boasVindas: '',
  instrucoes: 'instrucoes',
  documentosObrigatorios: 'documentos',
  dadosCandidato: 'dados-pessoais',
  enderecoCandidato: 'endereco',
  sobreEscola: 'pesquisa',
  dadosResponsavel: 'responsaveis',
  confirmacao: 'confirmacao',
  termos: 'termos',
  conclusao: 'conclusao',
  manutencao: 'manutencao',
}

export const APP_ROUTES: IAppRoute[] = [
  {
    name: 'welcome',
    title: 'Boas vindas',
    path: BASE_ROUTES.boasVindas,
    componentByCourse: {
      business: InitialPage,
      tech: InitialPage,
      vet: InitialPage,
    },
  },
  {
    name: 'instructions',
    title: 'Instruções',
    path: BASE_ROUTES.instrucoes,
    componentByCourse: {
      business: InstructionsPage,
      tech: InstructionsPage,
      vet: InstructionsPage,
    },
  },
  {
    name: 'documents',
    title: 'Documentos obrigatórios',
    path: BASE_ROUTES.documentosObrigatorios,
    componentByCourse: {
      business: DocumentsPage,
      tech: DocumentsPage,
      vet: DocumentsPage,
    },
  },
  {
    name: 'candidateData',
    title: 'Dados do candidato(a)',
    path: BASE_ROUTES.dadosCandidato,
    componentByCourse: {
      business: PersonalDataPage,
      tech: PersonalDataPage,
      vet: PersonalDataPage,
    },
  },
  {
    name: 'address',
    title: 'Endereço do candidato(a)',
    path: BASE_ROUTES.enderecoCandidato,
    componentByCourse: {
      business: AddressPage,
      tech: AddressPage,
      vet: AddressPage,
    },
  },
  {
    name: 'search',
    title: 'Sobre a escola',
    path: BASE_ROUTES.sobreEscola,
    componentByCourse: {
      business: SearchPage,
      tech: SearchPage,
      vet: SearchPage,
    },
  },
  {
    name: 'responsibles',
    title: 'Dados do(a) responsável',
    path: BASE_ROUTES.dadosResponsavel,
    componentByCourse: {
      business: ResponsiblePage,
      tech: ResponsiblePage,
      vet: ResponsiblePage,
    },
  },
  {
    name: 'confirmation',
    title: 'Confirmação',
    path: BASE_ROUTES.confirmacao,
    componentByCourse: {
      business: ConfirmationPage,
      tech: ConfirmationPage,
      vet: ConfirmationPage,
    },
  },
  {
    name: 'terms',
    title: 'Termos',
    path: BASE_ROUTES.termos,
    componentByCourse: {
      business: TermsPage,
      tech: TermsPage,
      vet: TermsPage,
    },
  },
  {
    name: 'conclusion',
    title: 'Conclusão',
    path: BASE_ROUTES.conclusao,
    componentByCourse: {
      business: ConclusionPage,
      tech: ConclusionPage,
      vet: ConclusionPage,
    },
  },
  {
    name: 'maintenance',
    title: 'Manutenção',
    path: BASE_ROUTES.manutencao,
    componentByCourse: {
      business: MaintenancePage,
      tech: MaintenancePage,
      vet: MaintenancePage,
    },
  },
]
